module.exports = __webpack_public_path__ + "static/media/FinancialData.0798baa2.jpg";